import React, { useCallback, useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai'
import { useAlert } from 'react-alert'
import PropTypes from 'prop-types'

import SearchCalendar from '../../Common/Atoms/Calendar'
import Button from '../../Common/Atoms/NormalButton'
import Select from '../../Common/Atoms/SelectAddValue'
import { CommonSearchStates, SetCommonSearch, SetWorkDate } from '../../Common/Slice/SearchSlice'
import { SetLoadSpinner } from '../../Common/Slice/LoadSpinnerSlice'
import { GetApi } from '../../Common/ApiAxios'
import Input from '../../Common/Atoms/Input'

import SearchWrap from '../Wrap/SearchWrap'

const Search = (props) => {
  const dispatch = useDispatch()
  const [renderFlg, setRenderFlg] = useState(false)
  const [plusButton, setPlusButton] = useState(false)
  const {
    title, showButton, onClick, onKeyDown, orderIdRef, firstSearch, grants,
    showCalendar,
    inSubCalendar, inSubChildren,
    addStyle, children, relationStatus
  } = props
  const alert = useAlert()
  const loginUserInfo = useSelector(state => state.loginUserInfo)

  // カレンダー
  const Calendar = () => {
    return (
      <li style={{ display: showCalendar ? 'flex' : 'none', zIndex: 3 }}>
        <label>日付</label>
        <SearchCalendar changeCalendar={changeCalendar} isViewIcon />
      </li>
    )
  }

  // 初期値
  useEffect(() => {
  // 必要なデータが更新された場合のみ実行
  // eslint-disable-next-line
  }, [loginUserInfo, dispatch])

  // レンダー終了判定

  // 初期検索
  useEffect(() => {
    if (renderFlg && firstSearch) {
      onClick()
    }
  }, [renderFlg, firstSearch, onClick])

  useEffect(() => {

  // 必要なデータが更新された場合のみ実行
  // eslint-disable-next-line
  }, [loginUserInfo, relationStatus])

  const changeCalendar = (date) => {
    if (!date) {
      dispatch(SetWorkDate(null))
      return null
    }
  }
  const viewSubSearch = false
  return (
    <SearchWrap addStyle={addStyle} plusButton={plusButton} viewSubSearch={viewSubSearch}>
      <h3>{title}</h3>
      <ul className='mainSearch'>
        <li>
          <label>ID</label>
          <Input type='text' name='orderId' inputRef={orderIdRef} onKeyDown={onKeyDown} disabled={grants.readGrantDivision === 3}
           width='12rem'
           />
        </li>
      </ul>
      {showButton && <Button margin='0 0 0 16px' name='検索' padding='0px' onClick={onClick} />}
    </SearchWrap>
  )
}

Search.propTypes = {
  title: PropTypes.string, // タイトル
  showButton: PropTypes.bool, // 検索ボタン表示
  onClick: PropTypes.func, // 検索処理
  onKeyDown: PropTypes.func, // キーダウン処理
  orderIdRef: PropTypes.object, // 検索項目関連
  firstSearch: PropTypes.bool, // 最初に検索処理をするか
  grants: PropTypes.object, // 権限関連
  inSubChildren: PropTypes.bool, // その他メニューをサブメニューに表示 メインには表示しない
  addStyle: PropTypes.string, // css用追加用
  children: PropTypes.any, // 子要素
}

export default Search
